module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_klippan-6d26f6a50802b134b1fed0ad272da20f.png";